import { StatusFilterPicker } from './StatusFilterPicker'
import { PriorityFilterPicker } from './PriorityFilterPicker'
import { AssigneeFilterPicker, CreatedByFilterPicker } from './AssigneeFilterPicker'
import { LabelFilterPicker } from './LabelFilterPicker'
import { ProjectFilterPicker } from './ProjectFilterPicker'
import { CycleFilterPicker } from './CycleFilterPicker'
import { DueFilterPicker } from './DueFilterPicker'
import { TextFilterInput } from './TextFilterInput'
import type { ValuePickerProps } from './types'
import type { FilterFieldKey } from '@/lib/types/filter'

export const VALUE_PICKER_MAP: Partial<
  Record<FilterFieldKey, React.ComponentType<ValuePickerProps>>
> = {
  status: StatusFilterPicker,
  priority: PriorityFilterPicker,
  assignee: AssigneeFilterPicker,
  createdBy: CreatedByFilterPicker,
  due: DueFilterPicker,
  labels: LabelFilterPicker,
  project: ProjectFilterPicker,
  cycle: CycleFilterPicker,
  name: TextFilterInput,
}

export type { ValuePickerProps } from './types'
